export const COLORS = {
  1: '#00A8B5',
  2: '#F49966',
}
